import React from "react";

type MobileBookingPaymentProps = {
  color?: string;
  size?: string;
};

const MobileBookingPayment = (props: MobileBookingPaymentProps) => {
  const { color, size } = props;
  
  const primaryColor = color || "#195FE9";
  
  if (size === "small") {
    return (
      <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
        <path d="M14 17L14 29.2952C14 30.1447 14.703 30.8333 15.5702 30.8333H18.5M14 17L14 15.5381C14 14.6886 14.703 14 15.5702 14H29.7025C30.5697 14 31.2727 14.6886 31.2727 15.5381V17M14 17H31.2727M31.2727 17V23.1429M18.5 25.4048H16.7273V28.119H18.5M31.7273 31H30.0672M27.9723 31H23.5455M16.7273 19.7143H28.5455V22.4286H16.7273V19.7143ZM22.3794 25.7441H32.8933C33.5045 25.7441 34 26.1999 34 26.762V27.6668V32.9821C34 33.5443 33.5045 34 32.8933 34H22.3794C21.7682 34 21.2727 33.5443 21.2727 32.9821V27.6668V26.762C21.2727 26.1999 21.7682 25.7441 22.3794 25.7441Z" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  if (size === "large") {
    return (
      <svg width="72" height="72" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
        <path d="M14 17L14 29.2952C14 30.1447 14.703 30.8333 15.5702 30.8333H18.5M14 17L14 15.5381C14 14.6886 14.703 14 15.5702 14H29.7025C30.5697 14 31.2727 14.6886 31.2727 15.5381V17M14 17H31.2727M31.2727 17V23.1429M18.5 25.4048H16.7273V28.119H18.5M31.7273 31H30.0672M27.9723 31H23.5455M16.7273 19.7143H28.5455V22.4286H16.7273V19.7143ZM22.3794 25.7441H32.8933C33.5045 25.7441 34 26.1999 34 26.762V27.6668V32.9821C34 33.5443 33.5045 34 32.8933 34H22.3794C21.7682 34 21.2727 33.5443 21.2727 32.9821V27.6668V26.762C21.2727 26.1999 21.7682 25.7441 22.3794 25.7441Z" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
      <path d="M14 17L14 29.2952C14 30.1447 14.703 30.8333 15.5702 30.8333H18.5M14 17L14 15.5381C14 14.6886 14.703 14 15.5702 14H29.7025C30.5697 14 31.2727 14.6886 31.2727 15.5381V17M14 17H31.2727M31.2727 17V23.1429M18.5 25.4048H16.7273V28.119H18.5M31.7273 31H30.0672M27.9723 31H23.5455M16.7273 19.7143H28.5455V22.4286H16.7273V19.7143ZM22.3794 25.7441H32.8933C33.5045 25.7441 34 26.1999 34 26.762V27.6668V32.9821C34 33.5443 33.5045 34 32.8933 34H22.3794C21.7682 34 21.2727 33.5443 21.2727 32.9821V27.6668V26.762C21.2727 26.1999 21.7682 25.7441 22.3794 25.7441Z" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default MobileBookingPayment; 